import { CommonConstants, HistoryConstants } from '@/config/constant';
import DOMPurify from 'dompurify';

const generateRandomString = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const sanitizeHTML = (html) => {
  return DOMPurify.sanitize(html);
};

const isNumber = (value) => {
  return Number.isInteger(Number(value));
};

const isValidUrl = (value) => {
  return CommonConstants.URL_PATTERN.test(value);
};

const isAlphanumeric = (value) => {
  return CommonConstants.ALPHANUMERIC_PATTERN.test(value);
};

const isWaiting = (status) => {
  return status && status == CommonConstants.STATUS_CHARGE.WAITING;
};

const isCancel = (status) => {
  return status && status == CommonConstants.STATUS_CHARGE.CANCEL;
};

const isDone = (status) => {
  return (status && status == CommonConstants.STATUS_CHARGE.DONE) || !status;
};

const isTicketDone = (status) => {
  return (status && status == CommonConstants.STATUS_CHARGE.TICKET_DONE) || !status;
};

const isCharge = (history) => {
  return history && history.feature === HistoryConstants.type.charge;
};

const isPayment = (history) => {
  return history && history.feature === HistoryConstants.type.payment;
};

const isRegister = (history) => {
  return history && history.feature === HistoryConstants.type.register;
};

const isRegisterCPM = (history) => {
  return history && history.feature === HistoryConstants.type.registerCPM;
};

const isOwn = (history) => {
  return history && history.type === HistoryConstants.chargeType.own.value;
};

const isManualCharge = (history) => {
  return history && isCharge(history) && history.type === HistoryConstants.chargeType.manual.value;
};

const isShopCharge = (history) => {
  return history && isCharge(history) && history.type === HistoryConstants.chargeType.shop.value;
};

const isIssuerCharge = (history) => {
  return history && isCharge(history) && history.type === HistoryConstants.chargeType.issuer.value;
};

const isCancelOrExpiredPayment = (history) => {
  const typeList = [ HistoryConstants.paymentType.cancel.value, HistoryConstants.paymentType.expired.value ];
  return history && isPayment(history) && typeList.includes(history.type);
};

const isCancelOrCancelIssuerOrExpiredPayment = (history) => {
  const typeList = [ HistoryConstants.paymentType.cancel.value, HistoryConstants.paymentType.expired.value, HistoryConstants.paymentType.issuerCancel.value ];
  return history && isPayment(history) && typeList.includes(history.type);
};

const isExpiredPayment = (history) => {
  return history && isPayment(history) && history.type === HistoryConstants.paymentType.expired.value;
};

const isIssuerCancelPayment = (history) => {
  return history && isPayment(history) && history.type === HistoryConstants.paymentType.issuerCancel.value;
};

export {
  generateRandomString,
  isWaiting,
  isDone,
  isCancel,
  isCharge,
  isPayment,
  isRegister,
  isManualCharge,
  isShopCharge,
  isCancelOrExpiredPayment,
  isCancelOrCancelIssuerOrExpiredPayment,
  isIssuerCancelPayment,
  isExpiredPayment,
  isIssuerCharge,
  isOwn,
  isNumber,
  isValidUrl,
  isTicketDone,
  sanitizeHTML,
  isRegisterCPM,
  isAlphanumeric,
};
